<template>
  <div class="studio_warp">
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="标签名称">
        <el-input v-model="searchForm.name" placeholder="请输入工作室名称" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <div>
      <el-button type="primary" @click="handleAdd">新增工作室</el-button>
    </div>
    <div class="table_warp">
      <custom-table border :column="column" :tableData="tableData" :showPages="true"
        :currentPageSize="searchForm.pageSize" :currentPage="searchForm.pageNum" :total="total"
        @pageChange="pageChange">
        <template slot="action" slot-scope="scope">
          <el-button type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </custom-table>
    </div>
    <custom-dialog :title="dialogObj.dialogTitle" v-if="dialogObj.show" width="750px" :visible="dialogObj.show"
      @close="dialogVisibleClose">
      <div slot="content" class="from-content">
        <el-form ref="addForm" :model="form" :rules="rules" label-width="110px" label-position="left">
          <el-form-item label="工作室名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入工作室名称" maxLength="10"></el-input>
          </el-form-item>
          <el-form-item label="工作室介绍" prop="introduce">
            <el-input type="textarea" :autosize="{ minRows: 10, maxRows:20 }" placeholder="请输入工作室介绍"
              v-model="form.introduce" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="成立日期" prop="establishDate">
            <el-date-picker v-model="form.establishDate" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="带头人姓名" prop="leaderId">
            <el-select v-model="form.leaderId" filterable remote reserve-keyword placeholder="请输入带头人姓名"
              :remote-method="remoteMethod" @change="leaderChange">
              <el-option v-for="item in doctorOptions" :key="item.doctorId" :label="item.doctorName"
                :value="item.doctorId">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="flex">
            <el-form-item label="首页背景图" prop="indexImage">
              <div v-if="form.indexImage">
                <img :src="form.indexImage" class="img" />
                <el-button icon="el-icon-edit" type="primary" @click="editBgImg" class="btn">修改图片</el-button>
              </div>
              <Upload v-else v-loading="indexImageLoading" ref="uploadImage" @on-success="handleBgImgSuccess"
                accept=".png,.jpg,.jpeg" class="mr8">
                <el-button class="upload" type="primary" size="small">
                  <i class="el-icon-plus"></i>
                </el-button>
              </Upload>
            </el-form-item>
            <el-form-item label="列表背景图" prop="listImage" class="ml5">
              <div v-if="form.listImage">
                <img :src="form.listImage" class="img" />
                <el-button icon="el-icon-edit" type="primary" @click="editListImg" class="btn">修改图片</el-button>
              </div>
              <Upload v-else v-loading="listImageLoading" ref="uploadImage" @on-success="handleListImgSuccess"
                accept=".png,.jpg,.jpeg" class="mr8">
                <el-button class="upload" type="primary" size="small">
                  <i class="el-icon-plus"></i>
                </el-button>
              </Upload>
            </el-form-item>
            <el-form-item label="带头人背景图" prop="leaderImage" class="ml5"> 
              <div v-if="form.leaderImage">
                <img :src="form.leaderImage" class="img" />
                <el-button icon="el-icon-edit" type="primary" @click="editLeaderImg" class="btn">修改图片</el-button>
              </div>
              <Upload v-else v-loading="leaderImageLoading" ref="uploadImage" @on-success="handleLeaderImgSuccess"
                accept=".png,.jpg,.jpeg" class="mr8">
                <el-button class="upload" type="primary" size="small">
                  <i class="el-icon-plus"></i>
                </el-button>
              </Upload>
            </el-form-item>
          </div>
          <div class="color1F2">专攻信息：</div>
          <div class="flex" v-for="(item, index) in form.specializeInfo">
            <el-form-item :label="'专攻方向' + (index + 1)" :prop="'specializeInfo.' + index + '.specialize'"
              :rules="{ required: true, message: '专攻方向不能为空', trigger: 'blur' }">
              <el-input v-model="item.specialize" placeholder="请输入专供方向" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="简要介绍 " class="ml10">
              <el-input v-model="item.introduce" placeholder="请输入简要介绍" maxlength="50"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="成员信息">
            <el-button type="text" @click="addMember">添加成员</el-button>
            <el-table :data="form.teamUserList" border style="width: 100%">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column label="姓名" prop="nickName">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.nickName" filterable remote reserve-keyword placeholder="请输入医生姓名"
                    :remote-method="getUserList" @change="membersChange($event, scope.row, scope.$index)">
                    <el-option v-for="item in userList" :key="item.id" :label="item.nickName" :value="item.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="工号" prop="userCode" width="80"></el-table-column>
              <el-table-column label="员工类型" prop="type" width="80">
                <template slot-scope="scope">{{ computedDict(scope.row.type, userType) }}</template>
              </el-table-column>
              <el-table-column label="医生类型" prop="doctorType" width="100">
                <template slot-scope="scope">{{ computedDoctorType(scope.row.doctorType) }}</template>
              </el-table-column>
              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="handleRemove(scope.row, scope.$index)">移除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="主要服务区域">
            <el-cascader v-model="form.serviceRegion" :options="options" @change="regionChange"></el-cascader>
          </el-form-item>

          <el-form-item label="共享病例" prop="caseShareFlag">
            <el-radio-group v-model="form.caseShareFlag">
              <el-radio :label="true">启用</el-radio>
              <el-radio :label="false">禁用</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="转诊" prop="referralFlag">
            <el-radio-group v-model="form.referralFlag">
              <el-radio :label="true">启用</el-radio>
              <el-radio :label="false">禁用</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="form-footer">
          <el-button type="primary" @click="addSave">保存</el-button>
          <el-button @click="dialogVisibleClose">取消</el-button>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
  </div>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import Upload from '@/components/Upload/Upload'
import customTable from '@/components/customTable/customTable'
import { debounce, dictText, deepClone, msgboxWarning, isNull,isNullObj } from "@/utils/validateBase";
import { queryClientList, doctorInfo } from "@/api/doctor"
import { provincesList } from '@/api/region'
import { uploadTemporaryFile } from "@/api/post"; // 科室请求
import { getUserList } from '@/api/user'
import { addTeam, teamList, teamDetail, deleteTeam } from '@/api/studio'
import { userType } from '@/utils/const'
export default {
  components: { CustomDialog, Upload, customTable },
  data() {
    return {
      column: [
        { label: '序号', type: 'index', width: '50' },
        { label: '工作室名称', prop: 'name' },
        { label: '带头人姓名', prop: 'leaderName' },
        { label: '成立日期', prop: 'establishDate' },
        { label: '团队成员', prop: 'teamMembers' },
        { label: '操作人', prop: 'updateBy' },
        { label: '操作时间', prop: 'updateTime' },
        {
          label: '状态 ', prop: 'status', formatter: (row => {
            return row.status == 1 ? '启用' : '禁用'
          })
        },
        { label: '操作 ', slotName: 'action' },

      ],
      searchForm: {
        name: null,
        pageSize: 10,
        pageNum: 1
      },
      dialogObj: {
        show: false,
        dialogTitle: '新增工作室'
      },
      form: {
        name: null,
        introduce: null,
        establishDate: null,
        indexImage: null,
        listImage: null,
        leaderImage: null,
        teamUsers: [],
        teamUserList: [],
        specializeInfo: [
          { specialize: '', introduce: '' },
          { specialize: '', introduce: '' },
        ],
        serviceRegion: [],
        caseShareFlag: 0,
        referralFlag: 0,
        status: 1
      },
      doctorOptions: [],
      tableData: [],
      indexImageLoading: false,
      listImageLoading: false,
      leaderImageLoading: false,
      userList: [],
      total: 0,
      options: [],
      rules: {
        name: { required: true, message: '请输入工作室名称', trigger: 'blur' },
        introduce: { required: true, message: '请输入工作室介绍', trigger: 'blur' },
        establishDate: { required: true, message: '请选择成立日期', trigger: 'change' },
        leaderId: { required: true, message: '请选择带头人姓名', trigger: 'change' },
        indexImage: { required: true, message: '请选择首页背景图', trigger: 'change' },
        listImage: { required: true, message: '请选择列表背景图', trigger: 'change' },
        leaderImage: { required: true, message: '请选择带头人背景图', trigger: 'change' },
        status: { required: true, message: '请选择状态', trigger: 'change' },
      },
      userType: userType
    }
  },
  created() {
    this.getList()
    this.getProvincesList()
  },
  computed: {
    computedDict() {
      return function (val, list) {
        return isNull(val) ? '' : dictText(val, list)
      }
    },
    computedDoctorType() {
      const map = [{ label: '医生', value: 1 }, { label: '理疗师', value: 2 }]
      return function (list) {
        let arr = []
        list && list.forEach(v => {
          arr.push(isNull(v) ? '' : dictText(v, map))
        })
        return arr.join(',')
      }
    }
  },
  methods: {
    dialogVisibleClose() {
      this.dialogObj.show = false;
      this.form = {
        name: null,
        introduce: null,
        establishDate: null,
        indexImage: null,
        listImage: null,
        leaderImage: null,
        teamUsers: [],
        teamUserList: [],
        specializeInfo: [
          { specialize: null, introduce: null },
          { specialize: null, introduce: null },
        ],
        serviceRegion: [],
        caseShareFlag: 0,
        referralFlag: 0,
        status: 1
      }
    },
    handleAdd() {
      this.userList = []
      this.doctorOptions = []
      this.form = {
        name: null,
        introduce: null,
        establishDate: null,
        indexImage: null,
        listImage: null,
        leaderImage: null,
        teamUsers: [],
        teamUserList: [],
        specializeInfo: [
          { specialize: null, introduce: null },
          { specialize: null, introduce: null },
        ],
        serviceRegion: [],
        caseShareFlag: 0,
        referralFlag: 0,
        status: 1
      }
      this.dialogObj.show = true;
    },
    addMember() {
      this.userList = []
      this.form.teamUserList.push({
        id: '',
        userCode: '',
        nickName: ''
      })
    },
    remoteMethod: debounce(async function (query) {
      let { code, rows } = await queryClientList({ searchValue: query, pageSize: 100, pageNum: 1 })
      if (code === 200) {
        this.doctorOptions = rows
      }
    }, 300, true),
    getUserList: debounce(async function (query) {
      let { code, rows } = await getUserList({ name: query })
      if (code === 200) {
        this.userList = rows
      }
    }, 300, true),
    // 图片上传成功的函数
    handleBgImgSuccess(data) {
      this.indexImageLoading = true
      let arr = []
      arr[0] = { uploadChannel: "postImg", fileId: data, groupName: "group1", isNeedThumbnail: "2" }
      uploadTemporaryFile(arr).then(uploadRes => {
        this.indexImageLoading = false
        if (uploadRes.errorCode == '0000') {
          this.form.indexImage = uploadRes.data[0].fullPathUrl
        } else {
          this.$message.error('上传失败')
        }
      }).catch(err => {
        this.indexImageLoading = false;
        this.$message.error('上传失败')
      })
    },
    // 清除图片地址，显示上传图片
    editBgImg() {
      this.form.indexImage = null;
    },
    // 图片上传成功的函数
    handleListImgSuccess(data) {
      this.listImageLoading = true
      let arr = []
      arr[0] = { uploadChannel: "postImg", fileId: data, groupName: "group1", isNeedThumbnail: "2" }
      uploadTemporaryFile(arr).then(uploadRes => {
        this.listImageLoading = false
        if (uploadRes.errorCode == '0000') {
          this.form.listImage = uploadRes.data[0].fullPathUrl
        } else {
          this.$message.error('上传失败')
        }
      }).catch(err => {
        this.listImageLoading = false;
        this.$message.error('上传失败')
      })
    },
    // 清除图片地址，显示上传图片
    editListImg() {
      this.form.listImage = null;
    },
    // 图片上传成功的函数
    handleLeaderImgSuccess(data) {
      this.leaderImageLoading = true
      let arr = []
      arr[0] = { uploadChannel: "postImg", fileId: data, groupName: "group1", isNeedThumbnail: "2" }
      uploadTemporaryFile(arr).then(uploadRes => {
        this.leaderImageLoading = false
        if (uploadRes.errorCode == '0000') {
          this.form.leaderImage = uploadRes.data[0].fullPathUrl
        } else {
          this.$message.error('上传失败')
        }
      }).catch(err => {
        this.leaderImageLoading = false;
        this.$message.error('上传失败')
      })
    },
    // 清除图片地址，显示上传图片
    editLeaderImg() {
      this.form.leaderImage = null;
    },
    membersChange(val, row, index) {
      let i = this.form.teamUserList.findIndex(v2 => { return v2.id == val })
      if (i > -1) {
        row.nickName = ''
        row.id = ''
        return this.$message.error('已添加过该成员')
      }
      let obj = this.userList.find(v1=>{ return val == v1.id})
      if(!isNull(obj) && !isNullObj(obj)){
        if(obj.doctorId == this.form.leaderId){
          row.nickName = ''
          row.id = ''
          return this.$message.error('不能添加带头人')
        }
        this.$set(this.form.teamUserList, index, obj)
      }
    },
    leaderChange(val) {
      let obj = this.doctorOptions.find(item => item.doctorId == val)
      this.form.leaderName = obj.doctorName
    },
    addSave() {
      this.$refs.addForm.validate(async valid => {
        if (valid) {
          let params = deepClone(this.form);
          let index = this.form.teamUserList.findIndex(v => { return isNull(v.id) })
          if (index > -1) {
            return this.$message.error('请检查团队成员信息')
          }
          let teamUsers = []
          params.teamUserList.forEach(v=>{ teamUsers.push(v.id) })
          params.teamUsers = teamUsers.join(',');
          let { code, data } = await addTeam(params);
          if (code == 200) {
            isNull(params.id) ? this.$message.success("添加成功！") : this.$message.success("修改成功！");
            this.dialogVisibleClose()
            this.getList()
          }
        }
      })
    },
    async getList() {
      let { code, rows, total } = await teamList(this.searchForm);
      if (code == 200) {
        this.tableData = rows || [];
        this.total = total;
      }
    },
    pageChange(obj) {
      let { current, size } = obj
      this.searchForm.pageNum = current
      this.searchForm.pageSize = size
      this.getList()
    },
    handleSearch() {
      this.searchForm.pageNum = 1
      this.getList()
    },
    handleReset() {
      this.searchForm = {
        name: null,
        pageNum: 1,
        pageSize: 10
      }
    },
    handleEdit: debounce(async function (row) {
      this.doctorOptions = []
      this.form.teamUserList = []
      let { code, data } = await teamDetail({ teamId: row.id })
      if (code === 200) {
        let obj = deepClone(data)
        this.doctorOptions.push({
          doctorId: obj.leaderId,
          doctorName: obj.leaderName,
        })
        this.form = obj
        this.form.serviceRegion = isNull(obj.serviceRegion) ? [] : obj.serviceRegion
        this.dialogObj.dialogTitle = '编辑工作室'
        this.dialogObj.show = true
      }

    }, 500, true),
    handleDelete(row) {
      msgboxWarning(this, {
        message: `是否确定删除该数据？`,
        confirmFn: async () => {
          let { code, data } = await deleteTeam({ teamId: row.id })
          if (code === 200) {
            this.$message.success('删除成功')
            this.getList()
          }
        },
        cancelFn: () => {
        },
      });
    },
    handleRemove(row, index) {
      this.form.teamUserList.splice(index, 1)
    },
    async getProvincesList() {
      let options = []
      let { code, rows } = await provincesList({ type: '0' })
      if (code == 200) {
        provincesList({ type: '1' }).then(res => {
          if (res.code == 200) {
            rows && rows.forEach(v1 => {
              let children = []
              res.rows && res.rows.forEach(v2 => {
                if (v1.provincesId == v2.parentId) {
                  children.push({
                    value: v2.provincesId,
                    label: v2.provincesName
                  })
                }
              })
              options.push({
                value: v1.provincesId,
                label: v1.provincesName,
                children
              })
            })
            this.options = options
          }
        })
      }
    },
    regionChange() {

    }
  }
}
</script>

<style lang="less" scoped>
.studio_warp {
  height: 100%;
  overflow: hidden;
  background: #fff;
  padding: 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .table_warp {
    flex: 1;
    overflow: auto;
    margin-top: 20px;
  }
}

.from-content {
  max-height: 600px;
  padding-right: 20px;
  overflow: auto;
}

.form-footer {
  text-align: right;
}

.img {
  width: 100px;
  height: auto;
  display: block;
}

.btn {
  margin-top: 5px;
}

.el-iamge {
  width: auto;
  height: 100px;
  margin-top: 5px;
}

.upload {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 2px;
  border: 1px dashed #D3D3D5;
  background-color: #FFF;
  color: #9AA0A8;
}
</style>